import React, { useMemo } from 'react'
import Item from './Item';

function AllDetailList({ comments, historys, worklogs ,cardId, boardPermission }) {
  const types = ["change_status", "card_assign", "create_card", "change_board"];
  const prepareHistory = useMemo(() => 
    historys.filter((el) => types.includes(el.response_object.event_type)),
    [historys, types]
  );

  const consolidateArray = useMemo(() => 
    [...prepareHistory, ...worklogs, ...comments].sort(
      (a, b) => new Date(b.consolidateTime) - new Date(a.consolidateTime)
    ),
    [prepareHistory, worklogs, comments]
  );


  return (
    <>
      {consolidateArray.map((item, idx) => (
        <Item
          item={item}
          key={`consolidate-card-item-${idx}`}
          cardId={cardId}
          boardPermission={boardPermission}
        />
      ))}
    </>
  );
}

export default React.memo(AllDetailList)